import React, { Component } from 'react';
import {
  Image,
  ImageBackground,
  Platform,
  ScrollView,
  StyleSheet,
  Text,
  TouchableHighlight,
  Button,
  View,
} from 'react-native';

import FirebaseConsult from '../firebase/firebase_consult.js'
import FirebaseUsers from '../firebase/firebase_users.js'
import Messaging from '../messaging.js';

import EonnStars from '../components/stars';
import EonnTitle from '../components/title';
import EonnEllipsis from '../components/ellipsis';
import EonnButton from '../components/button';
import { mstyles } from '../constants/MainStyles';
import common from '../common';

const styles = StyleSheet.create({
  issueBox: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    paddingTop: 30,
    paddingBottom: 25,
    borderBottomColor: '#ceced2',
    borderBottomWidth: 1,
    width: '100%',
  },
  issueImage: {
    width: 47,
    height: 47,
    marginBottom: 5,
  },
  issueText: {
    fontSize: 22,
    lineHeight: 24,
    marginTop: 0,
    marginRight: 0,
    marginBottom: 0,
    marginLeft: 12,
    maxWidth: 200,
  },
  waitingBox: {
    flexDirection:"column",
    maxWidth:450,
    justifyContent:'center',
    alignItems:'center',
    marginTop: 25,
  },
  waitingText: {
    fontSize:20,
    textAlign:'center'
  },
  profileButton: {
    borderBottomColor: '#ceced2',
    borderBottomWidth: 1,
    width: '100%',
  },
  profileButton2: {
    flexDirection: 'row',
    paddingTop: 20,
    paddingRight: 20,
    paddingBottom: 20,
    paddingLeft: 20,
    justifyContent:'center',
    alignItems:'center',
  },
  profileImage: {
    marginRight: 15,
    height:59,
    width:59,
    borderRadius: 30,
  },
  profileBox: {
    flex: 1,
  },
  profileTitle: {
    fontSize: 23,
    lineHeight: 27,
  },
  profileExp: {
    fontSize: 14,
    lineHeight: 16,
  },
  profilePrice: {
    fontSize: 21,
    lineHeight: 30,
    marginRight: 5,
  },
  profileDollar: {
    fontSize: 16,
  },
  profileArrow: {
    width: 19,
    height: 24,
  }
});

export default class Screen extends Component {

  constructor(props) {
    super(props);
    this.state = {
      bids: [],
      isWaitingForSpecificTech: !!global.techLink, // Track if we're waiting for a specific tech
      techAccepted: false, // Track if the specific tech has accepted
    };
    console.log("C_Request1");
    
    FirebaseConsult.getBids()
    .then(bids => {
      this.setState(prevState => ({
        bids: bids,
      }));
      FirebaseConsult.watchForBids(this.onBid);
    });
  }

  onBid = (bids) => {
    if (!bids || !Array.isArray(bids)) {
      console.log("No bids received or invalid bids data:", bids);
      this.setState({ bids: [] });
      return;
    }

    let previousBids = this.state.bids;

    const changedBid = bids.find((newBid, index) => {
      return !previousBids[index] || newBid.id !== previousBids[index].id;
    });
  
    console.log("bids: ", bids);

    // Check if we're waiting for a specific tech and if they've bid
    if (this.state.isWaitingForSpecificTech && global.techLinkBid?.t_uid) {
      const specificTechBid = bids.find(bid => bid.t_uid === global.techLinkBid.t_uid);
      if (specificTechBid && !this.state.techAccepted) {
        console.log("Specific tech has accepted the consultation:", specificTechBid);
        // Update global.bid with the actual bid data
        global.bid = { ...global.bid, ...specificTechBid };
        this.setState({ techAccepted: true });
        
        return; // Don't process other bids in tech link mode
      }
    }

    // Fetch latest rating data for each tech (normal bidding mode)
    const updatedBids = Promise.all(bids.map(async (bid) => {
      try {
        if (bid.t_uid) {
          const techData = await FirebaseUsers.getUserInfo(bid.t_uid);
          if (techData) {
            return {
              ...bid,
              t_stars: techData.stars || bid.t_stars || 4,
              t_ratings: techData.ratings || bid.t_ratings || 0,
            };
          }
        }
        return bid;
      } catch (error) {
        console.log("Error getting tech data:", error);
        return bid;
      }
    }));

    updatedBids.then(refreshedBids => {
      this.setState({
        bids: refreshedBids,
      });
    }).catch(error => {
      console.log("Error updating bids with ratings:", error);
      this.setState({
        bids: bids,
      });
    });
  }

  render() {
    return (
      <ScrollView style={mstyles.sContainer} contentContainerStyle={mstyles.sContent}>
        <EonnTitle
          checkmark={true}
          lines={[
            {text: 'Issue Submitted!', size: 27},
          ]}
          style={{marginBottom:0}}
        ></EonnTitle>
        {!this.state.isWaitingForSpecificTech && (
          <Text style={[mstyles.mfont, {fontSize: 20, lineHeight: 22, textAlign:'center', marginTop: 30, marginRight: 30, marginBottom: 30, marginLeft: 30}]}>
            No need to wait! We'll notify you via text message as soon as bids start coming in with a link to choose your preferred auto tech, so feel free to come back later.
          </Text>
        )}

        <View style={styles.issueBox}>
          <Image source={require('../assets/images/issue1.png')} style={styles.issueImage} />
          <Text style={[styles.text,styles.issueText]}>
            {global.consult.desc}
          </Text>
        </View>
        
        {this.state.isWaitingForSpecificTech
          ? (
              this.state.techAccepted 
                  ? (
                      <View style={styles.waitingBox}>
                        <Text style={[mstyles.mfont,styles.waitingText]}>
                          Good news! {global.techLinkBid?.t_name || 'Your selected mechanic'} has accepted your consultation request.
                        </Text>
                        <EonnButton
                          style={{marginTop: 20, marginBottom: 0}}
                          onPress={() => {
                            this.props.navigation.navigate('C_Request3_Stripe');
                          }}
                        >
                          Continue to Payment
                        </EonnButton>
                      </View>
                    )
                : (
                    <View style={styles.waitingBox}>
                      <Text style={[mstyles.mfont,styles.waitingText]}>
                        No need to wait! We'll notify you via text message as soon as {global.techLinkBid?.t_name || 'your selected mechanic'} accepts your consultation, so feel free to come back later.
                        <EonnEllipsis style={[mstyles.mfont,styles.waitingText]}/>
                      </Text>
                    </View>
                  )
            )
          : (
              this.state.bids[0] 
                ? this.state.bids.map((bid,i) =>
                    <TouchableHighlight
                      key={i}
                      onPress={() => {
                        console.log("uid",bid.t_uid);
                        global.bid = bid;
                        this.props.navigation.navigate('C_Request2');
                      }}
                      style={styles.profileButton}
                      underlayColor={'#e6e6eb'}
                    >
                      <View style={styles.profileButton2}>
                        <Image source={{uri: bid.t_profilePicture}} style={styles.profileImage} />

                        <View style={styles.profileBox}>
                          <Text style={[mstyles.mfont,styles.profileTitle]}>{bid.t_name}</Text>
                          <Text style={[mstyles.mfont,styles.profileExp]}>Experience: {bid.t_experience} Years</Text>
                          <EonnStars stars={bid.t_stars}>{bid.t_ratings}</EonnStars>
                        </View>
                        <Text style={[mstyles.mfont,styles.profilePrice]}><Text style={styles.profileDollar}>$</Text>{bid.price}</Text>
                        <Image source={require('../assets/images/arrow1.png')} style={styles.profileArrow} />
                      </View>
                    </TouchableHighlight>
                  )
                : <View style={styles.waitingBox}>
                    <Text style={[mstyles.mfont,styles.waitingText]}>Waiting for bids
                    <EonnEllipsis style={[mstyles.mfont,styles.waitingText]}/></Text>
                  </View>
            )
        }
        
        <EonnButton
          navigationProps={this.props.navigation}
          white={true} 
          onPress={() => {
            FirebaseConsult.cancelConsult()
            .then(() => {
              console.log("Consult cancelled");
            })
            .then(common.resetConsult())
            .then(() => {
              if (global.auth.currentUser) {
                this.props.navigation.navigate('C_Reports');
              } else {
                global.user = {};
                this.props.navigation.navigate('C_Profile1');
              }
            });
          }}
        >
        Cancel Request</EonnButton>

      </ScrollView>
    );
  }
}